(function ($) {
  'use strict';

  if (!$) return;

  function readWishlist() {
    try {
      var storedWishlist = JSON.parse(localStorage.getItem('wishlist') || '[]');

      if (!Array.isArray(storedWishlist)) return [];

      return storedWishlist.filter(function (handle, index) {
        return typeof handle === 'string' && handle.trim() && storedWishlist.indexOf(handle) === index;
      });
    } catch (error) {
      return [];
    }
  }

  function writeWishlist(wishlist) {
    try {
      localStorage.setItem('wishlist', JSON.stringify(wishlist));
      localStorage.setItem('user_wishlist_cnt', String(wishlist.length));
    } catch (error) {
      return;
    }
  }

  function syncWishlistState() {
    var wishlist = readWishlist();

    $('.wishlist-counter').text(wishlist.length);

    $('.wishlist[data-handle]').each(function () {
      var button = $(this);
      var isFavorite = wishlist.indexOf(button.attr('data-handle')) !== -1;

      button.toggleClass('active-wishlist', isFavorite);
      button.toggleClass('wishlist-custom-action', !isFavorite);
    });

    return wishlist;
  }

  function dispatchWishlistChange(action, handle, wishlist) {
    document.dispatchEvent(new CustomEvent('wishlist:changed', {
      detail: { action: action, handle: handle, wishlist: wishlist.slice() }
    }));
  }

  function initializeWishlist() {
    syncWishlistState();

    $(document)
      .off('click.themeWishlist', '.wishlist-custom-action')
      .on('click.themeWishlist', '.wishlist-custom-action', function (event) {
        event.preventDefault();

        var handle = $(this).attr('data-handle');
        var wishlist = readWishlist();

        if (!handle || wishlist.indexOf(handle) !== -1) return;

        wishlist.push(handle);
        writeWishlist(wishlist);
        syncWishlistState();
        dispatchWishlistChange('add', handle, wishlist);
      })
      .off('click.themeWishlist', '.active-wishlist')
      .on('click.themeWishlist', '.active-wishlist', function (event) {
        event.preventDefault();

        var handle = $(this).attr('data-handle');
        var wishlist = readWishlist().filter(function (wishlistHandle) {
          return wishlistHandle !== handle;
        });

        if (!handle) return;

        writeWishlist(wishlist);
        syncWishlistState();
        dispatchWishlistChange('remove', handle, wishlist);
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeWishlist, { once: true });
  } else {
    initializeWishlist();
  }

  document.addEventListener('wishlist:rendered', syncWishlistState);
})(window.jQuery);
